import map from '../assets/museu/map.png';
import wallCorners from '../assets/museu/wallCorners.png';
import grid from '../assets/museu/grid.png';
import './museum.css';
import { useState } from 'react';
import { useCallback } from 'react';
import { getMapPosition, isBehindWall, getDirectionClass, isSeated } from '../utils/Positions';
import { canMove, getFacedCarinha } from '../utils/Movement';
import carinhas, { ICarinha } from './carinhas';
import InfoBox from './infoBox';
import { Coordinate, Move } from '../model';
import NavigationButtons from './buttons.tsx/navigation';
import LeaveButton from './buttons.tsx/leave';
import Benches from './components/benches';
import Carinhas from './components/carinhas';
import { useEffect } from 'react';

const initialPosition = {
  x: 1,
  y: 11,
};

interface CoordState {
  coord: Coordinate;
  dir: Move;
}

const Museum = () => {
  const [coord, setCoord] = useState<CoordState>({
    coord: initialPosition,
    dir: 'up',
  });
  const [started, setStarted] = useState<boolean>(false);
  const [faced, setFaced] = useState<ICarinha | undefined>(undefined);
  const charClass = `character ${getDirectionClass(coord.coord, coord.dir)} ${started ? '' : 'animate'}`;

  useEffect(() => {
    setTimeout(() => {
      setStarted(true);
      setFaced(carinhas.find(c => c.key === 'intro'));
    }, 1100)
  }, []);

  const onUp = useCallback(() => {
    if (started && !faced) {
      setCoord(curr => {
        if (canMove('up', curr.coord, curr.dir)) {
          return {
            coord: { x: curr.coord.x, y: curr.coord.y - 1 },
            dir: 'up',
          };
        }
        if (!isSeated(curr.coord)) {
          return {
            coord: curr.coord,
            dir: 'up',
          };
        }

        return curr;
       });
    }
  }, [started, faced]);

  const onDown = useCallback(() => {
    if (started && !faced) {
      setCoord(curr => {
        if (canMove('down', curr.coord, curr.dir)) {
          return {
            coord:{ x: curr.coord.x, y: curr.coord.y + 1 },
            dir: 'down',
          };
        }
        if (!isSeated(curr.coord)) {
          return {
            coord: curr.coord,
            dir: 'down',
          };
        }
        
        return curr;
       });
    }
  }, [started, faced]);

  const onRight = useCallback(() => {
    if (started && !faced) {
      setCoord(curr => {
        if (canMove('right', curr.coord, curr.dir)) {
          return {
            coord: { x: curr.coord.x + 1, y: curr.coord.y },
            dir: 'right',
          };
        }
        if (!isSeated(curr.coord)) {
          return {
            coord: curr.coord,
            dir: 'right',
          };
        }
        
        return curr;
       });
    }
  }, [started, faced]);

  const onLeft = useCallback(() => {
    if (started && !faced) {
      setCoord(curr => {
        if (canMove('left', curr.coord, curr.dir)) {
          return {
            coord: { x: curr.coord.x - 1, y: curr.coord.y },
            dir: 'left',
          };
        }
        if (!isSeated(curr.coord)) {
          return {
            coord: curr.coord,
            dir: 'left',
          };
        }
        
        return curr;
       });
    }
  }, [started, faced]);

  const onSee = useCallback(() => setFaced(getFacedCarinha(coord.dir, coord.coord)), [coord.coord, coord.dir]);

  const onUnsee = useCallback(() => setFaced(undefined), []);

  const pos = getMapPosition(coord.coord);

  return (
    <div className="museu">
      <img
        alt="grid"
        className="planta"
        src={grid} 
        style={{
          top: `calc(50% + ${pos.top}px)`,
          left: `calc(50% - ${pos.left}px)`,
        }}
      />

      {isBehindWall(coord.coord) && <div className={charClass} />}

      <Benches coord={coord.coord} />
      <img
        alt="museu"
        className="planta"
        src={map} 
        style={{
          top: `calc(50% + ${pos.top}px)`,
          left: `calc(50% - ${pos.left}px)`,
        }}
      />
      <Carinhas coord={coord.coord} />

      {!isBehindWall(coord.coord) && <div className={charClass} />}

      <img
        alt="cantos"
        className="planta"
        src={wallCorners} 
        style={{
          top: `calc(50% + ${pos.top}px)`,
          left: `calc(50% - ${pos.left}px)`,
        }}
      />

      {faced ? (
        <>
          <InfoBox carinha={faced} />
          <LeaveButton onUnsee={onUnsee} />
        </>
      ) : (
        <NavigationButtons
          coord={coord.coord}
          dir={coord.dir}
          onUp={onUp}
          onDown={onDown}
          onRight={onRight}
          onLeft={onLeft}
          onSee={onSee}
        />
      )}
    </div>
  );
}

export default Museum;
